import {Component, Input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Store} from '@ngxs/store';
import {DeleteUser} from '../../../../state/actions/appState.users.actions';

@Component({
  selector: 'app-account-settings-modal',
  templateUrl: './delete-user-modal.component.html',
  styleUrls: ['./delete-user-modal.component.scss']
})
export class DeleteUserModalComponent {
  @Input() userName: string;

  constructor(
    private activeModal: NgbActiveModal,
    private store: Store
  ) {
  }

  onDeleteUser() {
    this.store.dispatch(new DeleteUser(this.userName)).toPromise().then(this.activeModal.close);
  }

  onCloseModal() {
    this.activeModal.dismiss();
  }
}
